// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3NEQ6","colMin":"styles_colMin__1N_8z","colCheckbox":"styles_colCheckbox__2wtI0"};